





























































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import AMSformTable from '@/components/AMSformTable.vue';
import AMSTable from '@/components/AMSTable.vue';
import AMSDialog from '@/components/AMSDialog.vue';
import AMSImg from '@/components/AMSImg.vue';
import request from '@/utils/request';
import { AppStore } from '@/store/modules/app';
import AMSSelectedProduct from '@/components/AMSSelectedProduct.vue';
import AMSUpload from '@/components/AMSUpload.vue';
import moment from 'moment';
import Utils from '@/utils/utils';
import { emptyRule, regRule, specialCharRule } from '../../utils/rules';
import { getOperations, accountHistories, getOpertaionName, accountHistoryDetail, accountUndo, accountMoneyList, rechargeStatus, editRecharge, delRecharge } from '@/api/customer';
import { getProductCount } from '@/api/product';
interface Form {
  customerFilter?: string;
  status?: Array<string>;
}
@Component({
  components: {
    'ams-formtable': AMSformTable,
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-dialog': AMSDialog,
    'ams-table': AMSTable,
    'ams-img': AMSImg,
    'ams-upload': AMSUpload
  }
})
export default class RechargeList extends Vue {
  public $refs!: {
    formtable: HTMLFormElement;
    imgupload: any;
    rechargeForm: any;
    undoReasonForm: any;
  };
  form: Form = {};
  selectedstatus: Array<any> = ['WaitConfirm'];

  @Watch('selectedstatus')
  onSelect(newValue: string[]) {
    this.form.status = newValue;
  }
  confirmType: string | undefined = '';
  BreadItem = [
    {
      text: '财务管理',
      disabled: false,
      href: 'rechargeList'
    },
    {
      text: '充值列表',
      disabled: true
    }
  ];
  confirmDialog: boolean = false;
  confirmLoading: boolean = false;
  rechargeAccountId: string = '';
  updateStatus: string = '';
  api: string = '/api/Customer/Account/Recharges';
  selected: Array<any> = [];
  selectAll: boolean = true;
  dialogTitle: string = '';
  showConfirmDialog: boolean = false;
  showInfoDialog: boolean = false;
  currentTime: string = new Date().toISOString().substr(0, 10);
  /**当前选中的订单 */
  order: any = null;

  // 修改内容
  menu: boolean = false;
  amount: any = '';
  date: string = new Date().toISOString().substr(0, 10);
  remark: string = '';
  /**上传的图片数量限制 必须每次都重置 */
  uploadLimit: number = 1;
  /**附件 */
  attachment: any[] = [];
  undoReason: string = '';
  /**选中的充值账户 */
  account: any = null;
  /**当前选中的客户 */
  selectAccount: any = null;
  /**充值账户 */
  items: any[] = [];
  rechargeAmount: string = '';
  // 充值类型
  rechargeType: string = 'Recharge';
  // 确认弹窗类型
  tipsType: string = '';

  headers: object[] = [
    {
      isSelectAll: (props: any) => {
        return props.item.status !== 'WaitConfirm';
      },
      width: 60,
      align: 'left'
    },
    {
      text: '客户名',
      align: 'left',
      sortable: false,
      value: 'name',
      width: 120,
      render: (h: any, params: any) => {
        return h('div', { ...Utils.stausRenderDiableColor(params.row.status) }, params.row['customer'] && params.row['customer'][params.keyName]);
      }
    },
    {
      text: '手机号',
      align: 'left',
      value: 'phone',
      render: (h: any, params: any) => {
        return h('div', { ...Utils.stausRenderDiableColor(params.row.status) }, params.row['customer'] && params.row['customer'][params.keyName]);
      }
    },
    {
      text: '充值账户',
      align: 'left',
      value: 'accountName',
      width: 150,
      status: 'status'
    },
    {
      text: '充值金额',
      align: 'right',
      value: 'amount',
      // isCurrency: true,
      // status: 'status',
      width: 150,
      render: (h: any, params: any) => {
        return h(
          'div',
          {
            style: {
              color: parseFloat(params.row.amount) < 0 ? 'red' : ''
            },
            ...Utils.stausRenderDiableColor(params.row.status)
          },
          Utils.formatCurrencyPrice(params.row.amount)
        );
      }
    },
    {
      text: '充值类型',
      align: 'left',
      value: 'rechargeType',
      width: 120,
      status: 'status',
      render: (h: any, params: any) => {
        return h('span', { ...Utils.stausRenderDiableColor(params.row.status) }, this.switchRechargeTypes(params.row.rechargeType));
      }
    },
    {
      text: '充值时间',
      align: 'left',
      value: 'operateTime',
      isFormatDateTime: true,
      width: 180,
      status: 'status'
    },
    {
      text: '备注',
      align: 'left',
      value: 'remark',
      width: 180,
      status: 'status',
      isToolTips: true
    },
    {
      text: '附件',
      align: 'left',
      sortable: false,
      render: (h: any, params: any) => {
        return (
          params.row.pictureKey &&
          h(AMSImg, {
            props: {
              pictureKey: params.row.pictureKey,
              pictureWidth: 40,
              pictureHeight: 40
            }
          })
        );
      },
      width: 90
    },
    {
      text: '状态',
      align: 'left',
      sortable: false,
      render: (h: any, params: any) => {
        return h(
          'span',
          {
            style: {
              color: this.switchStatus(params.row.status).color
            },
            class: {
              status: true
            },
            attrs: {
              'status-color': ''
            }
          },
          this.switchStatus(params.row.status).text
        );
      },
      width: 130
    },
    {
      text: '操作',
      value: 'actions',
      align: 'center',
      isDetail: [
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key, 'edit');
          },
          text: '修改',
          color: '#1ABC9C',

          isShowBtn: (row: any) => {
            return (row.status == 'WaitConfirm' || row.status == 'NotPass') && Utils.isPermission('FinanceManager.FinanceAccount.RechargeOrEdit');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key, 'Ban');
          },
          text: '撤销',
          color: '#1ABC9C',
          isShowBtn: (row: any) => {
            return row.status == 'Pass' && Utils.isPermission('FinanceManager.RechargeList.UndoRecharge');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key, 'process', 'Pass');
          },
          text: '审核通过',
          color: '#1ABC9C',
          isShowBtn: (row: any) => {
            return row.status == 'WaitConfirm' && Utils.isPermission('FinanceManager.RechargeList.Review');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key, 'process', 'NotPass');
          },
          text: '审核不通过',
          color: '#1ABC9C',
          isShowBtn: (row: any) => {
            return row.status == 'WaitConfirm' && Utils.isPermission('FinanceManager.RechargeList.Review');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key, 'Del');
          },
          text: '删除',
          color: '#1ABC9C',
          isShowBtn: (row: any) => {
            return (row.status == 'WaitConfirm' || row.status == 'NotPass') && Utils.isPermission('FinanceManager.RechargeList.Delete');
          }
        }
      ],
      width: 270
    }
  ];

  /**充值账户规则 */
  get rechargeAccountRules() {
    if (this.account) {
      return [];
    } else {
      return ['充值账户不能为空'];
    }
  }
  /**充值金额规则 */
  get rechargeAmountRules() {
    if (this.rechargeAmount != '') {
      const m = parseFloat(this.rechargeAmount);
      if (isNaN(m)) {
        const rule = (value: any) => {
          //特殊字符
          if (/[^\u4e00-\u9fa5a-zA-Z0-9\w]/g.test(value)) {
            return '请输入正确的充值金额';
          } else {
            const v = value.match(/^\d*(\.?\d{0,2})/g);
            if (v != null && v.length == 1 && v[0] == '') {
              return '请输入正确的充值金额';
            } else {
              return true;
            }
          }
        };
        return [rule];
      } else {
        // 需求变更: 可以输入负数
        // if (m <= 0) {
        //   return ['请输入大于零的充值金额'];
        // } else {
        let i = this.rechargeAmount.indexOf('.');
        if (i != -1) {
          let strs = this.rechargeAmount.split('.');
          if (strs.length >= 2) {
            //判断小数点 左右两边是否是数字
            let left = strs[0];
            let right = strs[1];
            if (left == '' || right == '') {
              return ['请输入正确的充值金额'];
            } else {
              return [];
            }
          } else {
            return [];
          }
        } else {
          return [];
        }
      }
      return [];
    } else {
      return ['充值金额不能为空'];
    }
  }
  get accountName() {
    return this.account ? this.account.name : '';
  }
  get enableSubmitButton() {
    return this.undoReason != '' && this.undoReason.length <= 50;
  }
  get undoReasonRules() {
    if (this.undoReason == '') {
      return ['撤销原因不能为空'];
    } else {
      return [];
    }
  }

  created() {
    if (this.$route.query.item) {
      this.selectAccount = this.$route.query.item;
      this.form = {
        customerFilter: this.selectAccount.name,
        status: ['WaitConfirm']
      };
    } else {
      this.initForm();
    }
  }
  getPermission(name: string) {
    return Utils.isPermission(name);
  }
  formatDateTime(date: any) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  }
  switchStatus(status: string) {
    switch (status) {
      case 'WaitConfirm':
        return { color: '#FE5500', text: '待审核' };
      case 'Pass':
        return { color: '#00A854', text: '审核通过' };
      case 'NotPass':
        return { color: '#FF0000', text: '审核不通过' };
      case 'Ban':
        return { color: '#999999', text: '已撤销' };
      default:
        return { color: '#454545', text: '' };
    }
  }

  computedDiscount(item: any) {
    if (item.discountPrice !== null) {
      return this.formatPrice(item.discountPrice);
    }
  }

  processing(type?: string, val?: any) {
    this.confirmType = type;
    this.updateStatus = val;
    this.confirmDialog = true;
    this.dialogTitle = this.computeTitle(type);
  }

  confirmItem(btn: any, row: any, key: string, type?: string, val?: any) {
    this.confirmType = type;
    this.dialogTitle = this.computeTitle(type);
    if (type == 'Ban') {
      this.onDetailClick(row.item);
    }
    if (type == 'edit') {
      this.order = row.item;
      if (this.order) {
        this.getAccount(row.item.customer.id);
      }
      // this.getHistoryDetail(row.item);
      this.amount = this.order.amount ? this.order.amount : this.amount;
      this.date = this.order.operateTime ? this.formatDate(this.order.operateTime, 'YYYY-MM-DD') : this.date;
      this.remark = this.order.remark ? this.order.remark : this.remark;
      this.rechargeType = this.order.rechargeType || 'Recharge';
      this.confirmDialog = true;
      this.rechargeAmount = this.order.amount.toString();
    }
    if (type == 'process') {
      this.rechargeAccountId = row.item.id;
      this.confirmDialog = true;
      this.order = row.item;
      this.updateStatus = val;
    }
    if (type === 'Del') {
      this.rechargeAccountId = row.item.id;
      this.confirmDialog = true;
    }
  }

  getHistoryDetail(item: any) {
    if (item && item.id && item.id != '') {
      accountHistoryDetail(item.id)
        .then((response: any) => {
          let data = response;
          this.account = Object.assign(
            {},
            {
              id: data.customerAccountId,
              name: data.accountName,
              balance: data.balance,
              customerId: item.customer.id
            }
          );
        })
        .catch(err => {
          AppStore.ShowError(err);
        });
    }
  }

  onDetailClick(item: any) {
    if (item && item.id && item.id != '') {
      accountHistoryDetail(item.id)
        .then(response => {
          this.order = response;
          this.order.creationTime = this.formatDate(this.order.creationTime, 'YYYY-MM-DD HH:mm:ss');
          this.order.operateName = getOpertaionName(this.order.operateType);
          this.order.showUndoReason = this.order.operateType == 'UndoRecharge';
          if (this.order.customer && this.order.customer.sales) this.order.salesStr = this.getNamesStrByList(this.order.customer.sales);
          if (this.order.customer && this.order.customer.beautyAdvisors) this.order.beautyAdvisorsStr = this.getNamesStrByList(this.order.customer.beautyAdvisors);

          this.order.amountDisplay = Utils.formatCurrencyPrice(this.order.amount);
          this.order.amountDisplay = parseInt(this.order.amount) < 0 ? this.order.amountDisplay : `+${this.order.amountDisplay}`;
          this.order.freezeAmount = Utils.formatCurrencyPrice(this.order.freezeAmount);
          this.order.balance = Utils.formatCurrencyPrice(this.order.balance);
          this.dialogTitle = this.computeTitle('Ban');

          this.confirmDialog = true;
        })
        .catch(error => {
          AppStore.ShowError(error);
        });
    }
  }
  /**选中了某个充值账户 */
  onAccountClick(v: any, i: any) {
    this.account = v;
  }
  /**获取充值账户 */
  getAccount(id: string) {
    accountMoneyList(id)
      .then((response: any) => {
        this.items = response.items;
        this.account = this.items.filter(i => {
          return i.name === this.order.accountName;
        })[0];
      })
      .catch(error => {
        AppStore.ShowError('获取充值账户失败');
      });
  }

  getNamesStrByList(items: any) {
    if (!items) {
      return '';
    }
    if (items.length <= 0) {
      return '';
    }
    let str = '';
    items.map((v: any) => {
      if (v.staff && v.staff.name) {
        str = v.staff.name + ',' + str;
      }
    });
    str = str.substring(0, str.length - 1);
    return str;
  }
  /**详情弹窗 是否撤销原因 */
  getShowUndoReason(type: string) {
    //撤消充值
    return type == 'UndoRecharge' ? true : false;
  }

  computeTitle(type?: string) {
    switch (type) {
      case 'Ban':
        return this.getInfoDialogTitle(this.order);
      case 'edit':
        return '客户充值修改';
      default:
        return '请确认';
    }
  }

  upDownRecharge(data: any) {
    const self = this;
    let formData = Object.assign({}, data);
    rechargeStatus(formData)
      .then((data: any) => {
        self.confirmDialog = false;
        self.confirmLoading = false;
        AppStore.ShowSuccess('操作成功！');
        (self.$refs.formtable as HTMLFormElement).query();
        (self.$refs.formtable as HTMLFormElement).clearSelected();
      })
      .catch(function(err: any) {
        self.confirmDialog = false;
      })
      .finally(() => {
        self.confirmLoading = false;
      });
  }
  getSelected(val: any) {
    this.selected = val;
  }
  initForm() {
    this.form = { status: ['WaitConfirm'] };
    this.selectedstatus = ['WaitConfirm'];
  }

  getInfoDialogTitle(order: any) {
    if (!order) return '';
    const head = `单号${order.number}`;
    if (order.operateType == 'Recharge' && !order.canUndo) {
      return `${head}(已撤销)`;
    } else {
      return head;
    }
  }
  getTimeTitle(type: string) {
    switch (type) {
      case 'Recharge': /// 充值
      case 'FreezeDifference': /// 冻结金额差值
      case 'OrderFreeze': /// 下单冻结
        return '创建时间';

      case 'CancelDedut': /// 取消扣款
      case 'UndoRecharge': /// 撤消充值
        return '撤销时间';

      case 'CancelFreeze': /// 取消冻结
      case 'Deduct': /// 扣款
        return '扣款时间';
      default:
        //Transfer 转账
        return '创建时间';
    }
    return '创建时间';
  }

  getShowUndoButton(order: any) {
    if (this.confirmType === 'Ban') {
      if (!order) return true;
      if (this.getPermission('FinanceManager.RechargeList.UndoRecharge')) {
        return !order.canUndo;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  /**点击弹窗确定 */
  submitAMSDialog(type: string) {
    switch (this.confirmType) {
      case 'Ban':
        if (this.order && this.order.customer && this.order.customer.isActive == true) {
          this.showConfirmDialog = true;
          this.tipsType = 'remark';
        } else {
          AppStore.ShowError('该用户已被禁用，无法撤销充值');
        }
        break;
      case 'process':
        this.confirmLoading = true;
        let arr: any = [];
        if (this.rechargeAccountId) {
          arr.push(this.rechargeAccountId);
        } else {
          this.selected.forEach((ele: any) => {
            arr.push(ele.id);
          });
        }
        this.upDownRecharge({
          status: this.updateStatus,
          historyIds: arr
        });
        this.rechargeAccountId = '';
        break;
      case 'edit':
        if ((this.$refs.rechargeForm as any).validate()) {
          this.tipsType = 'recharge';
          this.showConfirmDialog = true;
        }
        break;
      case 'Del':
        this.confirmLoading = true;
        delRecharge(this.rechargeAccountId)
          .then((response: any) => {
            AppStore.ShowSuccess('删除成功');
            this.confirmLoading = false;
            this.confirmDialog = false;
            this.rechargeAccountId = '';
            this.confirmType = '';
            (this.$refs.formtable as HTMLFormElement).query();
          })
          .catch((err: any) => {
            AppStore.ShowError(err.response.data.error.message);
            this.confirmDialog = false;
            this.rechargeAccountId = '';
            this.confirmType = '';
            (this.$refs.formtable as HTMLFormElement).query();
          })
          .finally(() => {
            this.confirmLoading = false;
          });
        break;
      default:
        this.confirmDialog = false;
        break;
    }
  }

  /**点击弹窗取消 */
  closeAMSDialog(type: any) {
    this.rechargeAccountId = '';
    if (this.confirmType == 'edit') {
      (this.$refs.rechargeForm as any).resetValidation();
      this.resetForm();
      (this.$refs.imgupload as any).resetLimit();
    }
    // else if (this.confirmType == 'Ban') {
    //   this.confirmDialog = false;
    // }
    this.confirmDialog = false;
  }

  // 点击确认弹窗确定
  sureDialog() {
    this.confirmLoading = true;
    switch (this.tipsType) {
      case 'recharge':
        if ((this.$refs.rechargeForm as any).validate()) {
          if (this.account && this.order && this.rechargeAmount != '') {
            let pictureKeyEdit = this.attachment.length > 0 ? this.attachment[0].pictureKey : this.order.pictureKey ? this.order.pictureKey : '';
            let dateEdit = this.date == this.currentTime ? moment.utc() : moment(this.date).utc();
            const params = {
              customerAccountId: this.account.id,
              customerId: this.order.customer.id,
              amount: this.rechargeAmount,
              rechargeTime: dateEdit,
              remark: this.remark,
              pictureKey: pictureKeyEdit,
              id: this.order.id,
              rechargeType: this.rechargeType
            };
            const _this = this;
            editRecharge(params)
              .then(response => {
                AppStore.ShowSuccess('修改成功');
                _this.showConfirmDialog = false;
                _this.confirmLoading = false;
                _this.confirmDialog = false;
                (_this.$refs.formtable as HTMLFormElement).query();
                _this.resetForm();
                (_this.$refs.imgupload as any).resetLimit();
              })
              .catch(error => {
                AppStore.ShowError(error.response.data && error.response.data.error && error.response.data.error.message ? error.response.data.error.message : '充值失败');
                _this.showConfirmDialog = false;
                _this.confirmDialog = false;
                _this.resetForm();
                (_this.$refs.imgupload as any).resetLimit();
              })
              .finally(() => {
                _this.confirmLoading = false;
              });
          } else {
            AppStore.ShowError('数据有误');
          }
        }
        break;
      case 'remark':
        const params = {
          id: this.order.id,
          reason: this.undoReason
        };
        accountUndo(params)
          .then((response: any) => {
            this.showConfirmDialog = false;
            this.confirmDialog = false;
            this.confirmLoading = false;
            this.undoReason = '';
            (this.$refs.undoReasonForm as any).resetValidation();
            AppStore.ShowSuccess('撤销充值成功');
            // this.initForm();
            (this.$refs.formtable as HTMLFormElement).query();
          })
          .catch((error: any) => {
            AppStore.ShowError(error.error.message);
          })
          .finally(() => {
            this.confirmLoading = false;
          });
        break;
      default:
        break;
    }
  }
  // 点击确认弹窗取消
  cancelDialog() {
    switch (this.tipsType) {
      case 'recharge':
        this.showConfirmDialog = false;
        break;
      case 'remark':
        this.undoReason = '';
        (this.$refs.undoReasonForm as any).resetValidation();
        this.showConfirmDialog = false;
      default:
        break;
    }
  }

  /**充值金额输入事件 */
  onRechargeAmountInput(value: string) {
    // let v = value.match(/^\d*(\.?\d{0,2})/g);
    let v = value.match(/^\-?\d*(\.?\d{0,2})/g);
    if (v != null && v.length == 1 && v[0] == '') {
      //不能输入空格
      if (value.length > 0 && value.trim().length == 0) {
        this.$nextTick(() => {
          this.rechargeAmount = '';
        });
      }
    } else {
      if (v != null && v.length > 0) {
        let s = v[0];
        this.$nextTick(() => {
          // 需求变更: 可以输入负数
          // if (parseFloat(s) <= 0) {
          //   this.rechargeAmount = s;
          // } else {
          let i = s.indexOf('.');
          if (i != -1) {
            let strs = s.split('.');
            let last = strs[strs.length - 1];
            if (last.length > 2) {
              this.rechargeAmount = parseFloat(s).toFixed(2);
            } else {
              this.rechargeAmount = s; //parseFloat(s).toFixed(2)
            }
          } else {
            if (s.length > 9) {
              //整数长度超过9位
              this.rechargeAmount = s.substr(0, 9);
            } else {
              //整数长度没有超过9位
              if (s.indexOf('.') == -1) {
                this.rechargeAmount = s;
              }
            }
            // }
          }
        });
      } else {
        console.log('格式有问题');
      }
    }
  }

  resetForm() {
    this.date = new Date().toISOString().substr(0, 10);
    this.rechargeAmount = '';
    this.remark = '';
    this.attachment = [];
    this.account = null;
    this.rechargeType = 'Recharge';
  }

  formatDate(date: string, type: string) {
    return moment(date).format(type);
  }
  formatPrice(num: number) {
    return Utils.formatCurrencyPrice(num);
  }
  onChargeTypeChange(value: any) {}
  // 充值类型枚举
  switchRechargeTypes(type: string) {
    switch (type) {
      case 'Recharge':
        return '充值';
      case 'ChangeBalance':
        return '余额变更';
      default:
        return '';
    }
  }
}
